import React, {Component} from 'react'
import CacheManager from '../../../cache/CacheManager'
import CacheKeys from '../../../cache/CacheKeys'
import GSTCollectUI from './GSTCollectUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class GSTCollectSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
    }
  }

  render() {
    return (
      <GSTCollectUI
        context={this.props.context}
        errorList={this.state.errorList}
        account={this.props.account}

        onSubmit={this.onSubmit}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onSubmit = () => {
    let context = this.props.context
    RestApiUtils.put(this.props.context,
      `/api/accounts/${context.session.accountId}/loans`,
      this.onSubmitCallback, {})
  }

  onSubmitCallback = (response) => {
    if (response.errorList.length === 0) {
      window.location.href = '/loans/' + response.loan.path + "/" + response.loan.loanId;
    }
  }
}

export default GSTCollectSF
